var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroku(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 60,
    viewBox: "0 0 19.2 9.6",
    preserveAspectRatio: "xMinYMin meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.53 7.025H1.405c-.267 0-.484-.217-.484-.484V2.435c0-.267.217-.484.484-.484H4.53c.267 0 .484.217.484.484V6.54c0 .267-.217.484-.484.484z",
    fill: "#6762a6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.486 6.327V4.312s.13-.482-1.614.197c-.003.01-.003-1.863-.003-1.863l.57-.004v1.2s1.597-.63 1.597.477v2.008h-.55zm.325-2.96h-.605c.218-.266.415-.722.415-.722h.625s-.107.297-.435.722zM1.878 6.323V5.176l.574.574-.574.574z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27 6.18V4.53c0-.116-.085-.167-.186-.167a1.77 1.77 0 0 0-.682.151V6.18h-.465V3.116h.465v1.01c.22-.08.484-.15.748-.15.422 0 .58.26.58.616v1.59zm1.33-1c.015.554.124.663.465.663.267 0 .57-.09.802-.178l.077.35c-.248.112-.55.22-.9.22-.775 0-.895-.426-.895-1.104 0-.372.027-.71.116-1.02.232-.09.543-.136.934-.136.636 0 .83.353.83.97v.236H8.6zm.59-.818c-.14 0-.36.004-.542.04-.02.093-.043.22-.05.457h.97c0-.322-.058-.496-.376-.496zm1.7.15V6.18h-.465V4.306a2.69 2.69 0 0 1 1.077-.298v.387c-.2.015-.43.04-.612.12zm1.84 1.72c-.694 0-1.008-.34-1.008-1.12 0-.825.415-1.14 1.008-1.14.694 0 1.007.34 1.007 1.12 0 .825-.415 1.14-1.007 1.14zm0-1.87c-.357 0-.554.205-.554.752 0 .597.167.73.554.73.356 0 .554-.202.554-.748 0-.597-.167-.732-.554-.732zm3.25 1.817h-.546c-.128-.34-.306-.7-.58-.992h-.244v.992h-.465V3.116h.465v1.76h.217a2.82 2.82 0 0 0 .546-.845h.523c-.178.36-.407.678-.663.938a6.57 6.57 0 0 1 .748 1.213zm.872.054c-.422 0-.58-.26-.58-.616V4.03h.46v1.647c0 .116.085.167.186.167a1.88 1.88 0 0 0 .705-.151V4.03h.465v1.868c-.55.302-.973.337-1.236.337z",
    fill: "#6762a6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroku);
export default __webpack_public_path__ + "static/media/heroku.8fcef77ce821df741109abcd2333625f.svg";
export { ForwardRef as ReactComponent };